
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'CatalogFilterStatusBar',
  props: {
    numberOfActiveFilter: {
      type: Number,
      default: 0,
    },
    filterColor: {
      type: String,
      default: '',
    },
    filterWidth: {
      type: String,
      default: '',
    },
    filterStones: {
      type: String,
      default: '',
    },
    sortType: {
      type: String,
      default: 'recommendation',
    },
  },
  emits: ['remove-filter', 'remove-sort'],
})
